import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const data = await login(String(email || '').trim(), String(password || '').trim());
      navigate(data.account_type === 'client' ? `/cliente/${data.tenant_slug}` : '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Usuário ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    setError('');
    setMessage('');
    if (!email.trim()) {
      setError('Digite seu e-mail, WhatsApp ou apelido no campo Usuário primeiro.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await authService.forgotPassword({ login: email });
      setMessage(data.message || 'Se o usuário foi reconhecido e tem e-mail cadastrado, enviamos o link.');
    } catch (err) {
      setError(err.response?.data?.error || 'Não foi possível enviar a recuperação de senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="/logo.png" alt="Arena Cyber Café" style={styles.logoImg} />
        <p style={styles.subtitle}>Acesso de jogadores e operadores</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          {message && <div style={styles.success}>{message}</div>}

          <div style={styles.field}>
            <label style={styles.label}>Usuário</label>
            <input
              type="text"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={styles.input}
              placeholder="E-mail, WhatsApp ou apelido"
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Senha</label>
            <div style={styles.passwordWrap}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ ...styles.input, paddingRight: 46 }}
                placeholder="••••••••"
                required
              />
              <button type="button" style={styles.eyeBtn} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button type="button" style={styles.forgotBtn} onClick={handleForgot} disabled={loading}>
            Esqueci minha senha
          </button>

          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <button type="button" style={styles.createBtn} onClick={() => navigate('/criar-conta')}>
          CRIAR CONTA
        </button>

        <p style={styles.hint}>Jogador: use seu e-mail, WhatsApp ou apelido.</p>
        <p style={styles.recoveryHint}>Recuperação: informe e-mail, WhatsApp ou nick. Se não houver e-mail no cadastro, peça ao balcão para redefinir a senha padrão da Arena.</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'radial-gradient(circle at 50% 30%, #14210a 0%, #0a0a0f 60%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
  },
  card: {
    background: '#14141f',
    border: '1px solid #262636',
    borderRadius: 16,
    padding: '40px 36px',
    width: 360,
    maxWidth: '90vw',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  },
  logoImg: { width: '100%', maxWidth: 240, height: 'auto', marginBottom: 6 },
  subtitle: { color: '#6b7280', fontSize: 14, marginBottom: 32 },
  form: { textAlign: 'left' },
  field: { marginBottom: 16 },
  label: { display: 'block', color: '#9ca3af', fontSize: 13, marginBottom: 6, fontWeight: 500 },
  input: {
    width: '100%', padding: '10px 14px',
    background: '#262636', border: '1px solid #374151',
    borderRadius: 8, color: '#fff', fontSize: 14,
    boxSizing: 'border-box', outline: 'none',
  },
  passwordWrap: { position: 'relative' },
  eyeBtn: { position: 'absolute', right: 6, top: 6, width: 34, height: 30, border: 0, borderRadius: 7, background: '#1a1a28', color: '#fff', cursor: 'pointer' },
  forgotBtn: { display: 'block', margin: '-4px 0 10px auto', background: 'transparent', border: 0, color: '#a3e635', fontSize: 12, cursor: 'pointer', padding: 0 },
  btn: {
    width: '100%', padding: '12px',
    background: 'linear-gradient(135deg, var(--accent), #65a30d)',
    border: 'none', borderRadius: 8,
    color: '#0a0a0f', fontSize: 15, fontWeight: 700,
    cursor: 'pointer', marginTop: 8,
  },
  createBtn: {
    width: '100%', padding: '11px', marginTop: 14,
    background: 'transparent', border: '1px solid var(--accent)', borderRadius: 8,
    color: 'var(--accent)', fontSize: 14, fontWeight: 700,
    letterSpacing: 0.4, cursor: 'pointer',
  },
  error: {
    background: '#450a0a', border: '1px solid #7f1d1d',
    color: '#fca5a5', borderRadius: 8,
    padding: '10px 14px', marginBottom: 16, fontSize: 13,
  },
  success: {
    background: '#10230a', border: '1px solid #3f6212',
    color: '#d9f99d', borderRadius: 8,
    padding: '10px 14px', marginBottom: 16, fontSize: 13,
  },
  hint: { color: '#4b5563', fontSize: 12, marginTop: 20 },
  recoveryHint: { color: '#6b7280', fontSize: 11, lineHeight: 1.35, marginTop: 8 },
};
